module.exports = __webpack_public_path__ + "media/images/signatures/laci_signature_black-cf085e68c45777dfb2d4cb8cdf745545.jpg";